// The MUI theme's h1-h6 variants are all hardcoded `color: "#FFF"` in
// theme/typography.js for the dark app shell, so they render invisible on a
// white dialog. Every dialog in the app hand-rolls font sizes to work around
// that, which is why this one drifted to four unrelated sizes.
//
// The scale is 20 / 16 / 14 so the XS dialog does not feel oversized.
// 14 is MUI body2 -- close to shrunk field labels -- and keeps card copy
// and helper text readable without matching the 16px input text.
//
// Emphasis is rationed: only the dialog title, the two step-one card labels and
// the preview headline carry weight 500. Everything else separates by size and
// colour instead, so no more than three strings are ever weighted at once.
export const GUTTER = 3; // 24px -- title, content and actions share one edge

export const text = {
  title: { fontSize: 20, fontWeight: 500, color: "text.primary" },
  // Card titles sitting above a description, so these keep their weight.
  optionLabel: { fontSize: 16, fontWeight: 500, color: "text.primary" },
  choiceLabel: { fontSize: 14, color: "text.primary" },
  optionHelp: { fontSize: 13, color: "text.secondary", lineHeight: 1.4 },
  help: { fontSize: 14, color: "text.secondary", lineHeight: 1.4 },
  summary: { fontSize: 14, fontWeight: 500, color: "text.primary" },
  // Location codes are compared down the list, so keep the digits aligned.
  previewName: { fontSize: 14, color: "text.primary", fontVariantNumeric: "tabular-nums" },
};

export const previewCard = {
  mt: 1,
  p: 2,
  borderRadius: 1,
  border: "1px solid",
  borderColor: "divider",
  bgcolor: "grey.50",
};
